import React from "react";
import "./WarningModal.css";
import CustomModal from "../customModal/CustomModal";
import { CustomButton } from "../../buttons/customButton/CustomButton";

type props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
};

export const WarningModal: React.FC<props> = ({ isOpen, onClose, title }) => {
  return (
    <CustomModal isOpen={isOpen} isHideCloseButton onClose={onClose}>
      <div className="warning-modal-container">
        <span className="warning-modal-title-text">Error</span>
        <span className="warning-modal-desc">{title}</span>
        <CustomButton title="Close" onPress={onClose} />
      </div>
    </CustomModal>
  );
};
